export default {
  label: {
    id: 'merchant_options_payment_payout_status_under_review',
    defaultMessage: 'Your KYB information are under review.',
  },
}
